import apiClient from './apiClient';

export const getVolunteers = async () => {
    try {
        const response = await apiClient.get('/volunteers.php?action=list');
        return response.data;
    } catch (error) {
        console.error('Errore nel recupero dei volontari:', error);
        throw error;
    }
};

export const addVolunteer = async (volunteerData) => {
    try {
        const response = await apiClient.post('/volunteers.php?action=create', volunteerData);
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiunta del volontario:', error);
        throw error;
    }
};

export const updateVolunteer = async (volunteerData) => {
    try {
        const response = await apiClient.post('/volunteers.php?action=update', volunteerData);
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'aggiornamento del volontario:', error);
        throw error;
    }
};

export const deleteVolunteer = async (id) => {
    try {
        const response = await apiClient.delete(`/volunteers.php?action=delete&id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Errore durante l\'eliminazione del volontario:', error);
        throw error;
    }
};

export const getVolunteerAttendances = async (date) => {
    try {
        const response = await apiClient.get(`/volunteers.php?action=attendances&date=${date}`);
        return response.data;
    } catch (error) {
        console.error('Errore nel recupero delle presenze:', error);
        throw error;
    }
};

export const markVolunteerAttendance = async (attendanceData) => {
    try {
        const response = await apiClient.post('/volunteers.php?action=mark_attendance', attendanceData);
        return response.data;
    } catch (error) {
        console.error('Errore durante la registrazione della presenza:', error);
        throw error;
    }
};

export const removeVolunteerAttendance = async (id) => {
    try {
        const response = await apiClient.delete(`/volunteers.php?action=delete_attendance&id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Errore durante la rimozione della presenza:', error);
        throw error;
    }
};

export const uploadVolunteerDocument = async (volunteerId, file) => {
    const formData = new FormData();
    formData.append('volunteer_id', volunteerId);
    formData.append('file', file);
    try {
        const response = await apiClient.post('/volunteer_documents.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    } catch (error) {
        console.error('Errore caricamento documento volontario:', error);
        throw error;
    }
};

export const deleteVolunteerDocument = async (id) => {
    try {
        const response = await apiClient.delete(`/volunteer_documents.php?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Errore eliminazione documento:', error);
        throw error;
    }
};
